
import { Calendar } from "lucide-react";
import { Investment } from "@/types/investment";
import { formatDate, formatCurrency } from "./utils";

interface BalloonPaymentAlertProps {
  investment: Investment;
}

const BalloonPaymentAlert = ({ investment }: BalloonPaymentAlertProps) => {
  if (!investment.hasBalloonPayment || !investment.balloonPaymentDueDate) {
    return null;
  }

  return (
    <div className="bg-orange-50 border border-orange-200 rounded-lg p-4 mb-6">
      <div className="flex items-center space-x-2 text-orange-800 mb-2">
        <Calendar className="h-5 w-5" />
        <span className="font-semibold">Balloon Payment Due</span>
      </div>
      <div className="text-sm text-gray-600">
        <span className="font-semibold">{formatCurrency(investment.balloonPaymentAmount || 0)}</span>
        {' '}due on {formatDate(investment.balloonPaymentDueDate)}
      </div>
    </div>
  );
};

export default BalloonPaymentAlert;
